// extracted by mini-css-extract-plugin
export var relativeWrapper = "Banner-module--relativeWrapper--2Ax7W";
export var decor = "Banner-module--decor--2sIsu";
export var button = "Banner-module--button--DTkut";
export var lineAbove = "Banner-module--lineAbove--1LwnG";
export var container = "Banner-module--container--1vWtW";
export var carousel = "Banner-module--carousel--2lo-B";
export var overlay = "Banner-module--overlay--2LCw5";
export var position = "Banner-module--position--1ivER";